<div class="container-fluid mb-5">
  <div class="row">
    <div class="col-12 mt-2">
      <form autocomplete="off" [formGroup]="form">
        <div class="card mb-3 bg-2">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <carteira-autocomplete
                  [schema]="carteiraSchema"
                ></carteira-autocomplete>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12">
                <lib-autocomplete [schema]="regraSchema"></lib-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <lib-datepicker-day
                  [schema]="dataInicioSchema"
                ></lib-datepicker-day>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <lib-datepicker-day
                  [schema]="dataFimSchema"
                ></lib-datepicker-day>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Status regra</mat-label>
                  <mat-select formControlName="status">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let s of status" [value]="s.id">
                      {{ s.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="card-footer clearfix">
            <div class="d-flex flex-row justify-content-end">
              <div class="pr-3">
                <button
                  mat-raised-button
                  [disabled]="(loadingAtualizar$ | async)"
                  (click)="page$.next(1)"
                  label="Atualizar"
                  title="Atualizar"
                  aria-label="left"
                >
                  <loading-icon
                  class="align-content-center"
                  [btnLabel]="'Atualizar'"
                  [loading]="loadingAtualizar$ | async"
                  ></loading-icon>
                </button>
              </div>
              <div class="pr-3">
                <button
                  color="primary"
                  [disabled]="form.invalid || (loadingExecutar$ | async)"
                  (click)="executar()"
                  mat-raised-button
                  label="Executar"
                  title="Executar"
                  aria-label="left"
                >
                  <loading-icon
                  class="align-content-center"
                  [btnLabel]="'Executar'"
                  [loading]="loadingExecutar$ | async"
                  ></loading-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <app-total-table
        [showRegistersPerPage]="true"
        [totalPorPagina]="pageSize"
        (onChange)="updatePageSize($event)"
        [totalRegistros]="this.totalRegistros"
      ></app-total-table>
      <table
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl"
      >
        <thead>
          <tr>
            <th>Usuário</th>
            <th>Horário Início</th>
            <th>Horário Fim</th>
            <th>Carteira/Grupo</th>
            <th>Regra</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Status</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let exec of execucoes">
            <tr class="element-row">
              <td>{{ exec.usuario }}</td>
              <td>{{ exec.dataInicioProcessamento | date : "dd/MM/yyyy HH:mm:ss" }}</td>
              <td>{{ exec.dataFimProcessamento | date : "dd/MM/yyyy HH:mm:ss" }}</td>

              <td>{{ exec.parameters.carteira != null ? exec.parameters.carteira : exec.parameters.grupoCarteira }}</td>
              <td>{{ exec.parameters.regra }}</td>
              <td>{{ exec.parameters.dataInicio | date : "dd/MM/yyyy" }}</td>
              <td>{{ exec.parameters.dataFim | date : "dd/MM/yyyy" }}</td>

              <td>{{ exec.status }}</td>
              <td class="pt-1 pb-1">
                <div class="d-flex flex-row justify-content-center">
                  <div class="pr-2">
                    <button
                      mat-icon-button
                      type="button"
                      (click)="parametros.openInfoDialog(exec.parameters)"
                      title="Ver Parâmetros"
                    >
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="pr-2" *ngIf="shouldDownload(exec)">
                    <button
                      mat-icon-button
                      type="button"
                      (click)="download(exec.id)"
                      title="Download do relatório"
                    >
                      <i class="fas fa-download" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="pr-2" *ngIf="exec.status == 'FALHA'">
                    <button
                      mat-icon-button
                      (click)="erro.openInfoDialog(exec.errorMessage)"
                      type="button"
                      title="Ver erro"
                    >
                      <i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <maps-pagination
      [pageNumber]="page$"
      [items]="paginationTotalPage"
      *ngIf="paginationTotalPage && paginationTotalPage > 0"
      (pageSend)="receiverPage($event)"
    ></maps-pagination>
  </div>
  <app-historico-parametros
    class="parametros"
    #parametros
  ></app-historico-parametros>
  <app-historico-erro
    class="erro"
    #erro
  ></app-historico-erro>
</div>
